import { StyleSheet } from "aphrodite";

const basicReleaseDetailsStyles = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        flexGrow: 1,
        gap: '8px',
        padding: '0 16px',
    },
    dataText: {
        fontSize: '22px',
        fontWeight: 600,
        maxWidth: '150px',
    },
});

export default basicReleaseDetailsStyles;